import Picker from 'rc-picker/lib/Picker';
import generateConfig from 'rc-picker/lib/generate/moment';
import enEN from 'rc-picker/lib/locale/en_US';
import React from 'react';
import { Moment } from 'moment';
import { isDateDisabled, getDisabledHours, getDisabledMinutes, correctDate } from '../../../helpers/hours';
import { t } from '@base/utils/helpers';
import styles from './challengeDatePicker.module.scss';

export default function ChallengeDatePicker(props: { date: Moment; onChange: (value: Moment) => void }) {
  return (
    <Picker
      style={{ flex: 1 }}
      className={styles.picker}
      value={props.date}
      locale={enEN}
      generateConfig={generateConfig}
      placeholder={t('select_date_of_challenge')}
      format="YYYY MMM DD hh:mm A"
      showTime={{ format: 'hh:mm A', use12Hours: true, showSecond: false }}
      onSelect={(value) => props.onChange(correctDate(value))}
      disabledDate={isDateDisabled}
      showNow={false}
      disabledHours={() => props.date && getDisabledHours(props.date)}
      disabledMinutes={(hour: number) => props.date && getDisabledMinutes(props.date, hour)}
    />
  );
}
